export const CARD_ISSUERS = {
  visa: 'VISA',
  mastercard: 'MASTERCARD',
  maestro: 'MAESTRO',
  americanExpress: 'AMERICAN_EXPRESS',
  discover: 'DISCOVER',
  diners: 'DINERS',
  uncategorized: 'UNCATEGORIZED'
}
